import { render, staticRenderFns } from "./SampleSelector.vue?vue&type=template&id=2ec7238b&scoped=true"
import script from "./SampleSelector.vue?vue&type=script&lang=ts"
export * from "./SampleSelector.vue?vue&type=script&lang=ts"
import style0 from "./SampleSelector.vue?vue&type=style&index=0&id=2ec7238b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7238b",
  null
  
)

export default component.exports